"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationProvider = void 0;
var translation_provider_1 = require("./translation-provider");
Object.defineProperty(exports, "TranslationProvider", { enumerable: true, get: function () { return translation_provider_1.TranslationProvider; } });
//# sourceMappingURL=index.js.map